/**
 * App-level `audit_events.event_type` values (PRD §5.1). Shared so the G-Admin
 * System logs filter Select and the server allow-list stay the same list.
 */

export const AUDIT_EVENT_TYPES = [
  "login_succeeded",
  "login_failed",
  "logout",
  "magic_link_issued",
  "magic_link_denied",
  "magic_link_redeemed",
  "invite_sent",
  "invite_link_copied",
  "password_reset_requested",
  "password_set",
  "session_revoked",
  "rate_limited",
  // Tenancy (PLAN.md D-30): these tables carry no audit triggers, so the service writes the row.
  "company_created",
  "company_updated",
  "company_archived",
  "company_restored",
  "company_deleted",
  "project_created",
  "project_updated",
  "project_archived",
  "project_restored",
  "project_deleted",
  "employee_added",
  "employee_updated",
  "employee_archived",
  "employee_restored",
  "employee_role_changed",
  "employee_email_changed",
  "assignment_created",
  "assignment_updated",
  "assignment_removed",
  "employees_imported",
  "month_locked",
  "month_unlocked",
  // Exports (PLAN.md D-47): each download is logged with actor + scope; nothing is persisted.
  "export_stundenzettel",
  "export_year_matrix",
  "export_admin_xlsx",
  "export_admin_csv",
  "export_attachments_zip",
  "reminder_settings_updated",
  "reminder_sent",
  "project_invites_sent",
  "settings_updated",
  "hours_imported",
  // GoBD A-05 / H-04: boot-time hash-chain verification outcome (Rz. 100).
  "audit_chain_verified",
  // Test-phase only (`/api/dev/switch-persona`); gated by isRoleSwitcherEnabled.
  "dev_persona_switched",
] as const;

export type AuditEventType = (typeof AUDIT_EVENT_TYPES)[number];

const AUDIT_EVENT_TYPE_SET: ReadonlySet<string> = new Set(AUDIT_EVENT_TYPES);

export function isAuditEventType(value: string): value is AuditEventType {
  return AUDIT_EVENT_TYPE_SET.has(value);
}
